import createIcon from '../../createIcon';

/**
 * @component @name Widgets
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuMzM5OCAxMy42NTQ3VjIxLjY1NDdIMjAuMzM5OFYxMy42NTQ3SDEyLjMzOThaTTIuMzM5ODQgMjEuNjU0N0gxMC4zMzk4VjEzLjY1NDdIMi4zMzk4NFYyMS42NTQ3Wk0yLjMzOTg0IDMuNjU0NzNWMTEuNjU0N0gxMC4zMzk4VjMuNjU0NzNIMi4zMzk4NFpNMTUuOTk5OCAyLjM0NDczTDEwLjMzOTggNy45OTQ3M0wxNS45OTk4IDEzLjY1NDdMMjEuNjU5OCA3Ljk5NDczTDE1Ljk5OTggMi4zNDQ3M1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Widgets = createIcon('Widgets', [
  [
    'path',
    {
      d: 'M12.3398 13.6547V21.6547H20.3398V13.6547H12.3398ZM2.33984 21.6547H10.3398V13.6547H2.33984V21.6547ZM2.33984 3.65473V11.6547H10.3398V3.65473H2.33984ZM15.9998 2.34473L10.3398 7.99473L15.9998 13.6547L21.6598 7.99473L15.9998 2.34473Z',
      key: 'h2th8g',
    },
  ],
]);

export default Widgets;
